import { c as _c } from "react/compiler-runtime";
import type { FilterTypeConfig } from "../types";
import { useMemo } from "react";
import { useProviders } from "@/hooks/use-providers";
import { formatStaffName } from "@/lib/format-data";

/**
 * Provider filters need an options array built from the loaded providers
 * list (for display-value lookup in the inline pill, and for the
 * provider-strategy search). This hook returns a getter that callers use
 * per-filter to inject those options.
 */
export function useProviderOptions() {
  const $ = _c(5);
  const {
    providers
  } = useProviders();
  let t0;
  bb0: {
    if (!providers) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== providers) {
      t1 = providers.map(_temp);
      $[1] = providers;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const providerOptions = t0;
  let t1;
  if ($[3] !== providerOptions) {
    t1 = filterType => {
      if (filterType.type === "provider") {
        return providerOptions;
      }
      return filterType.options;
    };
    $[3] = providerOptions;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(p) {
  return {
    value: p.id,
    label: formatStaffName(p)
  };
}